import { render } from "./Logout.vue?vue&type=template&id=3b77c0ce&scoped=true&ts=true"
import script from "./Logout.vue?vue&type=script&lang=ts"
export * from "./Logout.vue?vue&type=script&lang=ts"

import "./Logout.vue?vue&type=style&index=0&id=3b77c0ce&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b77c0ce"]])

export default __exports__